var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_c('h1',[_vm._v("TIME REMAINING")]),_c('hr'),_c('Countup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }